import React from 'react'
import { default as MuiTooltip } from '@mui/material/Tooltip'
import { formattedDate } from 'utils/formatters'
import { injectIntl, FormattedMessage, InjectedIntlProps } from 'react-intl'
import Icon from 'components/Icon'
import messages from './messages'
import styles from './LicenseTooltip.scss'

interface License {
  licenseName?: string
  licenseNumber?: string
  type?: string
  dbaName?: string
  date?: string
  licenseRegisteredAddress?: string
}

interface LicenseTooltipProps extends InjectedIntlProps {
  licenses: License[]
}

const rows = [
  { key: 'licenseName' },
  { key: 'licenseNumber' },
  { key: 'type' },
  { key: 'dbaName' },
  { key: 'date', formatter: formattedDate },
  { key: 'licenseRegisteredAddress' },
]

const LicenseTooltip = ({ intl, licenses }: LicenseTooltipProps) => {
  if (!licenses || licenses.length === 0) return null

  const content = (license: License) => (
    <div className={styles.tooltip}>
      {rows
        .filter(({ key }) => !!license[key as keyof License])
        .map(({ key, formatter = (value: string) => value }) => {
          const value = license[key as keyof License]
          const formattedValue = formatter(value ? String(value) : '')

          return (
            <div key={key} className={styles.row}>
              <div className={styles.title}>
                {/* @ts-ignore */}
                <FormattedMessage {...messages.rows[key]} />
              </div>
              <div className={styles.content}>{formattedValue}</div>
            </div>
          )
        })}
    </div>
  )

  return (
    <div className={styles.container}>
      <div className={styles.license}>
        <MuiTooltip placement='bottom' title={content(licenses[0])} classes={{ tooltip: styles.tooltip }}>
          <span>
            <Icon name='license' size='regular' className={styles.headerText}>
              License
            </Icon>
          </span>
        </MuiTooltip>
      </div>
    </div>
  )
}

export default injectIntl(LicenseTooltip)
